import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortArrowUpBlue = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.66696 12.5254V5.07871L11.9203 8.33204C12.1803 8.59204 12.607 8.59204 12.867 8.33204C13.127 8.07204 13.127 7.65204 12.867 7.39204L8.47363 2.99871C8.21363 2.73871 7.79363 2.73871 7.53363 2.99871L3.13363 7.38538C2.87363 7.64538 2.87363 8.06538 3.13363 8.32538C3.39363 8.58538 3.81363 8.58538 4.07363 8.32538L7.33363 5.07871V12.5254C7.33363 12.892 7.63363 13.192 8.0003 13.192C8.36696 13.192 8.66696 12.892 8.66696 12.5254Z",
		fill: "#C2D3FF"
	})
});
export default SvgSortArrowUpBlue;
